import React, { useState, useEffect } from "react";
import { BtnPrimary } from "../../share/buttons/Btn";
import DragandDropWithoutbtn from "../../share/dragAndDropFile/DragandDropWithoutbtn";
import { useForm } from "react-hook-form";
import DatePickerInput from "../../share/input/DatePicker";
import BootCampMember from "../../../Components/layouts/StudentCourse/BootCampMember";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import MessageQuill from "../Message/MessageQuill";
import moment from "jalali-moment";
import useFetch from "../../../Hooks/useFetch";
import { Modal } from "../../share/modal/Modal";

function GeneralInfo() {
    const [upload, setUpload] = useState(false);
    const [file, setFile] = useState("");
    const [categories, setCategories] = useState();
    const [organizers, setOrganizers] = useState();
    const [participate, setParticipate] = useState();
    const [bootcampName, setBootcampName] = useState("");
    const [bootcampStart, setBootcampStart] = useState("");
    const [bootcampEnd, setBootcampEnd] = useState("");
    const [bootcampDescription, setBootcampDescription] = useState("");

    const [generalInfoData, setGeneralInfoData] = useState({
        bootcamp_name: "",
        category: "",
        bootcamp_start_time: "",
        bootcamp_end_time: "",
        bootcamp_description: "",
        bootcamp_cover: "",
    });

    const [call, setCall] = useState();

    useEffect(() => {
        setGeneralInfoData({
            ...generalInfoData,
            bootcamp_name: bootcampName,
        });
    }, [bootcampName]);

    useEffect(() => {
        setGeneralInfoData({
            ...generalInfoData,
            bootcamp_start_time: moment(
                bootcampStart,
                "HH:mm:ss jYYYY/jMM/jDD"
            ).format(),
        });
    }, [bootcampStart]);

    useEffect(() => {
        setGeneralInfoData({
            ...generalInfoData,
            bootcamp_end_time: moment(
                bootcampEnd,
                "HH:mm:ss jYYYY/jMM/jDD"
            ).format(),
        });
    }, [bootcampEnd]);

    useEffect(() => {
        setGeneralInfoData({
            ...generalInfoData,
            bootcamp_description: bootcampDescription,
        });
    }, [bootcampDescription]);

    const getCategories = useFetch({
        method: "GET",
        url: "BootCampService/bootcamp_categories",
        noHeader: false,
        trigger: true,
        setter: setCategories,
    });
    const getParticipate = useFetch({
        method: "GET",
        url: "BootCampService/11/bootcamp_participants",
        noHeader: false,
        trigger: true,
        setter: setParticipate,
    });
    //Todo : id bootcamp dynamic she

    const getOrganizer = useFetch({
        method: "GET",
        url: "OrganizerService/organizers",
        noHeader: false,
        trigger: true,
        setter: setOrganizers,
    });

    const getGeneralInfo = useFetch({
        method: "GET",
        url: `BootCampService/11`,
        noHeader: false,
        trigger: true,
        setter: setGeneralInfoData,
    });
    //Todo : id bootcamp dynamic she

    const editGeneralInfo = useFetch({
        method: "PATCH",
        url: `BootCampService/11`,
        noHeader: false,
        data: call,
        trigger: false,
        caller: getGeneralInfo,
    });
    //Todo : id bootcamp dynamic she

    const submitForm = () => {
        const formData = new FormData();

        formData.append("category", generalInfoData.category);
        formData.append("bootcamp_name", generalInfoData.bootcamp_name);
        formData.append(
            "bootcamp_start_time",
            generalInfoData.bootcamp_start_time
        );
        formData.append("bootcamp_end_time", generalInfoData.bootcamp_end_time);
        formData.append(
            "bootcamp_description",
            generalInfoData.bootcamp_description
        );
        formData.append("bootcamp_cover", file[0]);

        setCall(formData);
        editGeneralInfo.reFetch();
    };

    useEffect(() => {
        generalInfoData.bootcamp_start_time &&
            setBootcampStart(
                moment(generalInfoData?.bootcamp_start_time)
                    .locale("fa", { useGregorianParser: true })
                    .format("HH:mm:ss YYYY/MM/DD")
            );
        generalInfoData.bootcamp_start_time &&
            setBootcampEnd(
                moment(generalInfoData.bootcamp_end_time)
                    .locale("fa", { useGregorianParser: true })
                    .format("HH:mm:ss YYYY/MM/DD")
            );
    }, [generalInfoData.bootcamp_start_time]);

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const handleModal = () => {
        setUpload((perv) => !perv);
    };
    return (
        <div className="p-16">
            <div className="flex justify-between items-center">
                <h4 className="text-[2rem] text-purple-dark font-bold">
                    اطلاعات کلی بوت کمپ
                </h4>
                <BtnPrimary
                    text="نمایش لیست شرکت کنندگان"
                    className="px-16 py-7"
                    onClick={handleModal}
                />
            </div>
            <div className=" bg-[#FBF7FF] rounded-[1.5rem] py-[4.3rem] px-[6.7rem] mt-[4.3rem]">
                <form onSubmit={handleSubmit(submitForm)}>
                    <div className="mb-[3.2rem]">
                        <DragandDropWithoutbtn
                            bootcamp_cover={generalInfoData?.bootcamp_cover}
                            setFile={setFile}
                            type="image"
                        />
                    </div>
                    <input
                        register={{
                            required: {
                                value: true,
                                message: "Enter Name",
                            },
                        }}
                        type="text"
                        name="name"
                        full={true}
                        control={control}
                        placeholder="نام دوره*"
                        className="block input border-gray h-[6.4rem] w-full text-[#21212199] bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[3.2rem]"
                        value={generalInfoData.bootcamp_name}
                        onChange={(e) => setBootcampName(e.target.value)}
                    />
                    <select
                        register={{
                            required: {
                                value: true,
                                message: "Enter Name",
                            },
                        }}
                        type="text"
                        name="name1"
                        control={control}
                        placeholder="برگزار کننده"
                        className="input border-gray h-[6.4rem] w-full text-[#21212199] bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[3.2rem]"
                    >
                        {organizers?.results.map((organizer) => {
                            return (
                                <option key={organizer.id} value={organizer.id}>
                                    {organizer.organizer_name}
                                </option>
                            );
                        })}
                    </select>
                    <select
                        register={{
                            required: {
                                value: true,
                                message: "Enter Name",
                            },
                        }}
                        type="text"
                        name="name1"
                        control={control}
                        placeholder="دسته بندی"
                        className="input border-gray h-[6.4rem] w-full text-[#21212199] bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[3.2rem]"
                    >
                        {categories?.results.map((category) => {
                            return (
                                <option key={category.id} value={category.id}>
                                    {category.category_name}
                                </option>
                            );
                        })}
                    </select>
                    <div className="mb-[3.2rem]">
                        <DatePickerInput
                            register={{
                                required: true,
                            }}
                            setDate={setBootcampStart}
                            message="تاریخ شروع بوت‌کمپ"
                            placeholder="تاریخ شروع بوت‌کمپ *"
                            name="bootcamp_start_time"
                            control={control}
                            defaultValue={bootcampStart}
                            plugins={[<TimePicker position="bottom" />]}
                        />
                    </div>
                    <div className="mb-[3.2rem]">
                        <DatePickerInput
                            register={{
                                required: true,
                            }}
                            setDate={setBootcampEnd}
                            message="تاریخ پایان بوت‌کمپ"
                            placeholder="تاریخ پایان بوت‌کمپ *"
                            name="bootcamp_end_time"
                            control={control}
                            defaultValue={bootcampEnd}
                            plugins={[<TimePicker position="bottom" />]}
                        />
                    </div>
                    <MessageQuill
                        placeholder="توضیحات *"
                        setValue={setBootcampDescription}
                        value={generalInfoData.bootcamp_description}
                    />
                    <button
                        className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                        type="submit"
                    >
                        <span>ثبت</span>
                    </button>
                </form>
            </div>
            <Modal show={upload} closeModal={handleModal}>
                <BootCampMember
                    close={setUpload}
                    participants={participate?.results}
                />
            </Modal>
        </div>
    );
}

export default GeneralInfo;
